import { defineComponent, shallowRef, toRaw } from 'vue';
import pkg from '../../package.json';
import { loadScript } from './loadScript';
let lastEditorId = 0;
export default defineComponent({
    name: 'EmailEditor',
    props: {
        editorId: String,
        minHeight: {
            type: String,
            default: '500px',
        },
        options: {
            type: Object,
            default: () => ({}),
        },
        scriptUrl: String,
        /**
         * @Deprecated Props: Use `options.appearance` instead
         */
        appearance: Object,
        /**
        * @Deprecated Props: Use `options.locale` instead
        */
        locale: String,
        /**
        * @Deprecated Props: Use `options.projectId` instead
        */
        projectId: Number,
        /**
        * @Deprecated Props: Use `options.tools` instead
        */
        tools: Object,
    },
    computed: {
        id() {
            return this.editorId || `editor-${++lastEditorId}`;
        },
    },
    setup() {
        const editor = shallowRef(null);
        const createSerializedEditor = (originalEditor) => {
            if (!originalEditor)
                return null;
            return {
                ...originalEditor,
                registerCallback: (event, callback) => {
                    originalEditor.registerCallback(event, (data, done) => {
                        callback(data, (result) => {
                            const rawResult = toRaw(result);
                            done(rawResult);
                        });
                    });
                }
            };
        };
        return {
            editor,
            createSerializedEditor,
        };
    },
    mounted() {
        loadScript(this.loadEditor.bind(this), this.scriptUrl);
    },
    methods: {
        loadEditor() {
            const options = toRaw(this.options) || {};
            if (this.appearance) {
                options.appearance = toRaw(this.appearance);
            }
            if (this.locale) {
                options.locale = this.locale;
            }
            if (this.projectId) {
                options.projectId = this.projectId;
            }
            if (this.tools) {
                options.tools = toRaw(this.tools);
            }
            const rawEditor = unlayer.createEditor({
                ...options,
                id: this.id,
                source: {
                    name: pkg.name,
                    version: pkg.version,
                },
            });
            // Wrap the editor with serialization handling
            this.editor = this.createSerializedEditor(rawEditor);
            this.$emit('load');
            this.editor?.addEventListener('editor:ready', () => {
                this.$emit('ready');
            });
        },
        /**
         * @deprecated This method will be removed in the next major release. Use `editor.exportHtml` instead.
         */
        exportHtml(callback) {
            this.editor?.exportHtml(callback);
        },
        /**
         * @deprecated This method will be removed in the next major release. Use `editor.loadDesign` instead.
         */
        loadDesign(design) {
            this.editor?.loadDesign(design);
        },
        /**
        * @deprecated This method will be removed in the next major release. Use `editor.saveDesign` instead.
        */
        saveDesign(callback) {
            this.editor?.saveDesign(callback);
        }
    },
});
